@if (dspAdvertiserRequest()) {
  <app-request-creation-status-page [dspAdvertiserRequest]="dspAdvertiserRequest()!" />
} @else {
  <app-overlay-layout
    *transloco="let t"
    variant="promo"
    [title]="t('overlays.dsp_no_linked_advertiser_title')"
    [subtitle]="t('overlays.dsp_no_linked_advertiser_subtitle')"
  >
    @let globalAdvertiser = linkableGlobalAdvertiser();
    <ng-container ngProjectAs="[overlayBody]">
      <app-overlay-feature-list
        [featureKeys]="[
          'overlays.dsp_no_linked_advertiser_benefit_1',
          'overlays.dsp_no_linked_advertiser_benefit_2',
          'overlays.dsp_no_linked_advertiser_benefit_3',
        ]"
      />
      @if (isAdmin() && globalAdvertiser) {
        <p
          [innerHTML]="
            t('dsp-stats.global_advertiser_linked_on_another_marketplace', {
              advertiser: '<strong>' + globalAdvertiser.name + '</strong>',
            })
          "
        ></p>
      }
    </ng-container>
    <ng-container ngProjectAs="[overlayCta]">
      @if (isAdmin() && globalAdvertiser) {
        <button iButton [loading]="isLinkingGlobalAdvertiser()" (click)="linkGlobalAdvertiser()">
          {{ t("dsp-stats.link_it_to_this_marketplace") }}
        </button>
      } @else if (isAdmin()) {
        <button iButton (click)="linkDspAdvertiser()">{{ t("overlays.link_dsp_advertiser") }}</button>
        @if (canRequestAdvertiser()) {
          <a iButton variant="secondary" routerLink="/dashboard/advertiser-creation-request">
            {{ t("overlays.create_dsp_advertiser") }}
          </a>
        }
      }
    </ng-container>
  </app-overlay-layout>
}
